export default {
    unsubscribed_contacts_delete_title: "Eliminar contactos dados de baja",
    unsubscribed_contacts_delete_do_you_want_to: "¿Desea eliminar los contactos dados de baja?",
    unsubscribed_contacts_delete_have_been_removed: "Los contactos dados de baja se han eliminado",
}